var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUseitPrideDark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 319,
  height: 316,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#useit-pride-dark_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#7E16A8",
  fillRule: "evenodd",
  d: "M0 315.36h318.96v-52.801H0z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00F",
  fillRule: "evenodd",
  d: "M0 263.282h318.96v-52.801H0z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#31A335",
  fillRule: "evenodd",
  d: "M0 211.204h318.96v-52.801H0z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7F740",
  fillRule: "evenodd",
  d: "M0 158.403h318.96v-52.801H0z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7B140",
  fillRule: "evenodd",
  d: "M0 105.602h318.96V52.801H0z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DB3030",
  fillRule: "evenodd",
  d: "M0 52.801h318.96V0H0z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#040B28",
  d: "M267.488 266.192H57.401c-3.52 0-6.401-2.881-6.401-6.401V55.849c0-3.52 2.88-6.4 6.401-6.4h203.686c3.52 0 6.401 2.88 6.401 6.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M124.422 93.168h6.593v40.328c0 7.809-6.529 14.082-14.595 14.082h-1.28c-8.13 0-14.595-6.337-14.595-14.21v-40.2h6.529v40.328c0 4.416 3.585 8.065 8.322 8.065h.832c4.673 0 8.258-3.521 8.258-8.001V93.168zm49.033 26.309h-6.402c0-3.201-2.816-6.209-6.145-6.209h-1.472c-3.009 0-5.761 1.984-5.761 4.673 0 7.745 19.588 4.737 19.588 18.627 0 6.145-6.082 11.074-12.803 11.074h-1.664c-7.746 0-12.995-5.889-12.995-11.97v-.896h6.146v.704c0 3.585 3.2 6.657 7.105 6.657h1.408c3.521 0 6.529-2.432 6.529-5.697 0-8.129-19.779-5.505-19.779-18.051 0-6.337 5.569-10.69 12.226-10.69h1.472c8.386.064 12.547 6.849 12.547 11.778m38.407 15.619h6.337c0 5.889-5.761 12.482-13.827 12.482h-1.28c-8.129 0-14.595-6.337-14.595-14.21v-11.651c0-7.809 6.466-14.018 14.595-14.018h1.408c8.066 0 14.339 6.209 14.339 14.018v7.81H194.77v4.225c0 4.608 3.777 8.385 8.642 8.385h.832c4.673.064 7.618-4.033 7.618-7.041m-17.22-13.571v2.433h17.988v-2.433c0-4.608-3.585-8.257-8.45-8.257h-.896c-4.865 0-8.642 3.649-8.642 8.257m-94.353 69.197v-5.505h19.204v32.838h11.778v5.505h-30.982v-5.505h13.058v-27.333zm12.29-17.475c0-1.856 1.537-3.393 3.393-3.393h.256c1.856 0 3.393 1.537 3.393 3.393s-1.537 3.393-3.393 3.393h-.256c-1.856.064-3.393-1.473-3.393-3.393m33.286 38.727v-37.639h6.21v10.882h21.38v5.505h-21.38v20.804c0 3.841 3.008 7.297 7.233 7.297h.768c3.841 0 6.977-3.456 6.977-7.297h6.338c0 7.297-4.801 12.866-13.571 12.866h-.768c-8.386 0-13.187-5.569-13.187-12.418m53.898 7.809c0-2.048 1.665-3.776 3.777-3.776 2.048 0 3.777 1.664 3.777 3.776 0 2.049-1.665 3.777-3.777 3.777-2.048 0-3.777-1.664-3.777-3.777"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "useit-pride-dark_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h319v316H0z"
})))));
export default SvgUseitPrideDark;